import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const PackedOrders = () => {
  return (
    <>
      <OrderTable status={4} isActive="packed" />
    </>
  );
};

export default PackedOrders;
